import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: { label: string; path: string };
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action
}: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 md:mb-10 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        {eyebrow && (
          <p className="mb-3 flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-600">
            <span className="h-3 w-1 rounded-full bg-accent-500" aria-hidden="true" />
            {eyebrow}
          </p>
        )}
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {description && (
          <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">
            {description}
          </p>
        )}
      </div>
      {action && (
        <Link
          to={action.path}
          className="inline-flex w-fit items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-500"
        >
          {action.label}
          <i className="ri-arrow-right-line text-base" aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}